import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const linksMap = {
  plaid: (
    <Link href="/collection/ties?pattern=Plaid" className="tracker-text-ties_plaid-230525-133341">
      {'plaid'}
    </Link>
  ),
  black: (
    <Link href="/collection/ties?pattern=&color=Black" className="tracker-text-ties_black-230525-133342">
      {'black'}
    </Link>
  ),
  rent: (
    <Link href="/collection/tuxedos-and-suits" className="tracker-text-ties_rent-230525-133343">
      {'rent your suit'}
    </Link>
  ),
};

const TiesCopy = () => (
  <Layout1x1>
    <h3 data-testid="ties-title" className="text-h2">
      {'Ties for Your Suit and Tuxedo | Accessory Collection'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="ties-desc" className="text-gray-darker">
      {
        'Complete your suit or tuxedo look with a tie from Menguin. With hundreds of men’s suit ties and tuxedo ties to choose from, you’re sure to find the perfect one for your outfit.'
      }
    </p>
    <p data-testid="ties-desc" className="text-gray-darker">
      {
        'Our suit ties from our pre-tied collection are delivered to your door and ready to wear out of the box. Our ties are made with a pre-tied knot, so you can save time getting dressed and get to your event on time. Plus, you’ll have the added bonus of sporting a picture-perfect tie knot all day and night.'
      }
    </p>
    <p data-testid="ties-desc" className="text-gray-darker">
      Why not add a touch of personality to your look? Our suit ties also come in printed fabrics. Pair a solid shirt with a classic print
      such as paisley, stripe, {linksMap.plaid}, dots, and more. Our tuxedo ties are also available in solid fabric colors. Choose from cool
      winter colors such as red, {linksMap.black}, brown. If the weather is warmer, opt for pink, yellow, or a pastel shade. Each color
      comes in a variety of hues, from light to dark, so you can color match the perfect one for you. Start browsing and {linksMap.rent} tie
      today.
    </p>
  </Layout1x1>
);

export default TiesCopy;
